import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { DotLoaderOverlay } from "react-spinner-overlay";
import { ReactComponent as Clock } from "../../assets/icons/clock.svg";
import { ReactComponent as Search } from "../../assets/icons/search.svg";

import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import ModalComponent from "../../components/ModalComponent";
import {
  formatDate,
  formatTime,
  formatRupiah,
} from "../../helpers/functionFormat";
import { getDetailRiwayat } from "../../redux/actions";

const DetailRiwayat = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const intervalRef = useRef(null);

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState({
    title: "Daftar Penawar",
    show: false,
    body: null,
  });

  const updateTime = () => {
    const currentDate = new Date();
    setDate(formatDate(currentDate, 3));
    setTime(formatTime(currentDate));
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getDetailRiwayat({ auction_id: id, search })
      );
      setListData(response.data);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const onShowListPenawar = (data) => {
    setModal({
      title: "Daftar Penawar",
      show: true,
      body: (
        <div className="max-h-96 overflow-y-scroll">
          {data.map((history, index) => (
            <div
              key={history.id}
              className={`flex justify-between items-center px-6 py-2 ${
                index < data.length - 1 && "border-b"
              }`}
            >
              <div>
                <div className="font-semibold">
                  {history?.buyer?.full_name ?? "Offline Bidder"}
                </div>
                <div className="text-[#646566] text-[14px] mt-[4px]">
                  {history?.buyer?.email ?? "-"}
                </div>
              </div>
              <div className="font-semibold">
                {history?.offer_price &&
                  formatRupiah(history?.offer_price, ".")}
              </div>
            </div>
          ))}
        </div>
      ),
    });
  };

  useEffect(() => {
    updateTime();
    intervalRef.current = setInterval(updateTime, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className="pb-4">
      <DotLoaderOverlay
        loading={loading}
        overlayColor="rgba(0,0,0,0.1)"
        color={"#CF1701"}
      />
      <ModalComponent
        className="w-2/5"
        show={modal.show}
        closeModal={() => setModal((prev) => ({ ...prev, show: false }))}
        title={modal.title}
        body={modal.body}
      />
      <div className="flex px-1 md:px-24 my-8">
        <div className="md:flex md:justify-between bg-white w-2/3 md:w-4/5 py-4 p-2 rounded-lg items-center md:px-4 card">
          <span className="text-third font-semibold text-md md:text-sm">
            Jakarta | {date}
          </span>
          <div className="flex items-center mt-1 md:mt-0">
            <Clock className="mr-1 w-4 md:mr-2 md:w-6" />
            <span className="text-third text-sm">{time}</span>
          </div>
        </div>
        <Button
          bgColor="bg-third"
          className="w-1/3 md:w-1/5 ml-4  px-0 md:px-6"
          title="Kembali Ke Beranda"
          onClick={() => history.push("/beranda")}
        />
      </div>
      <div className="mx-1 md:mx-24 bg-white rounded-lg py-1 card min-h-5/6 overflow-x-scroll">
        <div className="flex items-center justify-between py-2 px-4 border-b">
          <h3 className="text-lg font-bold">Riwayat Lelang</h3>
          <div className="md:w-1/4 w-2/3">
            <TextInput
              className="flex flex-1 border-0 px-1 m-1 font-sourceSansPro focus:outline-none focus:border-none"
              lefticon={<Search />}
              placeholder="Cari lot atau tipe mobil"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        {listData.map((item, index) => (
          <div
            key={index}
            className={`flex items-center px-4 py-2 justify-between ${
              index % 2 === 1 ? "bg-white" : "bg-[#F9FAFB]"
            }`}
          >
            <div className="w-1/4 md:w-3/10">
              <label className="block text-primary text-md font-semibold mb-1">
                Lot-{item.lot_number}
              </label>
              <label className="block text-md text-third font-semibold">
                {item.stock_unit?.unit_name}
              </label>
            </div>
            <div className="w-1/4 md:w-3/10 mx-1">
              <label className="block text-secondary text-sm mb-1">
                Harga Penawaran
              </label>
              <label className="block text-md text-third">
                {item?.final_price && formatRupiah(item.final_price, ".")}
              </label>
            </div>
            <div className="w-1/4 md:w-3/10 mx-1">
              <label className="block text-secondary text-sm mb-1">
                Pemenang
              </label>
              <label className="block text-md text-third">
                {item.buyer?.full_name ?? "-"}
              </label>
            </div>
            <div className="w-1/4 md:w-1/10">
              <label className="block text-secondary text-sm mb-1">
                {`Jumlah Penawar ${
                  item.stock_unit?.auction_progresses?.length || 0
                }`}
              </label>
              <div className="items-center">
                <label className="mr-2 md:inline block">
                  {item.stock_unit?.auction_progresses?.length > 0}
                </label>
                {item.stock_unit?.auction_progresses.length > 0 ? (
                  <Button
                    bgColor="bg-[#FFEBEC]"
                    title={
                      <span className="text-primary">Lihat Daftar Penawar</span>
                    }
                    onClick={() =>
                      onShowListPenawar(item.stock_unit?.auction_progresses)
                    }
                  />
                ) : //   Lihat Daftar Penawar
                // </utton>
                null}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailRiwayat;
